import { getCurrentEnvironment } from "./api";
const env = getCurrentEnvironment().environment.replace("stage", "stg");
var foderName = "DCOPDev";
var ssrsIp = "10.20.36.4";
if(env.toLowerCase() == "dev"){
    foderName = "DCOPDev";
    ssrsIp = "10.20.36.4";
} 
else if (env.toLowerCase() == "test"){
    foderName = "DCOPTest";
}
else if (env.toLowerCase() == "stg"){
    foderName = "DCOPStage";
    ssrsIp = "10.20.36.4";
}
else if (env.toLowerCase() == "prod"){
    foderName = "DCOPProd";
    ssrsIp = "10.30.36.4";
}

export const Request_List = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Request List&rs:Command=Render&rs:ClearSession=true&rs:Format=`;
export const Tenant_List = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Tenant List&rs:Command=Render&rs:ClearSession=true&rs:Format=`;
export const Tenant_Contact_List = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Tenant Contact List&rs:Command=Render&rs:ClearSession=true&rs:Format=`;
export const Incident_List = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/HSE Incident List&rs:Command=Render&rs:ClearSession=true&rs:Format=`;
export const Report_List = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Dashboard/Replaceable&rs:Command=Render&rs:ClearSession=true&rs:Format=`;
export const Security_Incident_List = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Security Incident List&rs:Command=Render&rs:ClearSession=true&rs:Format=`;
export const BRR_ABRF_Form = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/BRR_ABRF_Form&rs:Command=Render&rs:Format=PDF&rs:ClearSession=true&`;
export const PRINT_HSE_FORM = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/HSE Observation Form&rs:Command=Render&rs:Format=PDF&rs:ClearSession=true&`;
export const PRINT_SECURITY_FORM = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Security Incident Form&rs:Command=Render&rs:Format=PDF&rs:ClearSession=true&`;
export const PRINT_REQUEST_FORM = `http://${ssrsIp}/ReportServer?/${foderName}/DCOP Reports/Request Form {badgeType}&rs:Command=Render&rs:Format=PDF&rs:ClearSession=true&`;

